import { defineMessages } from 'react-intl';

export default defineMessages({
  scaleCasesTitle: {
    id: 'transation.recap.scale_cases.title',
  },
  documentsTitle: {
    id: 'recap_page.documents_bloc_title',
  },
  updateTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.edit',
  },
  updateButtonTitle: {
    id: 'transaction.update_drawer.title',
  },
  addVictim: {
    id: 'preopening_page.victim.add_victim',
  },
  transactionContactStep: {
    id: 'transaction.contact_step.title',
  },
  transactionContactSubTitle: {
    id: 'transaction.contact_step.sub_title',
  },
  managementMode: {
    id: 'manager_recap_validation_drawer.management_mode',
  },
  responsibilty: {
    id: 'preopening_page.claim_circumstances.responsibilty',
  },
  responsibility: {
    id: 'preopening_page.claim_circumstances.responsibilty',
  },
  description: {
    id: 'preopening_page.claim_circumstances.description',
  },
  circumstance: {
    id: 'saham_drawer.validation.circumstance',
  },
  scaleCase: {
    id: 'saham_drawer.validation.scale_case',
  },
  circumstanceDetail: {
    id: 'saham_drawer.validation.circumstance_detail',
  },
  rejectButton: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.reject',
  },
  validateButton: {
    id: 'legal_proceeding_page.judgement_add.income_certificate.validate',
  },
  managerDecision: {
    id: 'manager.decision.title',
  },
  statusTitle: {
    id: 'court_manager_legal_proceedings_page.expert_report.decision.status',
  },
  decidedByTitle: {
    id: 'court_manager_legal_proceedings_page.step.validator',
  },
  reasonTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.rejection.reason',
  },
  rejectTransaction: {
    id: 'transaction.reject_transaction',
  },
  cancelRejectTransaction: {
    id: 'transaction.cancel_reject_transaction',
  },
  dateReception: {
    id: 'transaction.date_reception',
  },
  victimCin: {
    id: 'preopening_page.victim.cin',
  },
  victimFirstName: {
    id: 'preopening_page.victim.first_name',
  },
  victimLastName: {
    id: 'preopening_page.victim.last_name',
  },
  tutorTitle: {
    id: 'transaction.tutor.title',
  },
  revenueFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.revenue_field',
  },
  modificationAfterValidation: {
    id: 'transaction.update_after_validation.title',
  },
  beneficiarySuccessToast: {
    id: 'add_beneficiary_success',
  },
});
